import { AbcFitnessBrandLogo } from "@/components/portal/AbcFitnessBrandLogo";
import { useBrandHomeRoute } from "@/hooks/useBrandHomeRoute";

interface AuthBrandHeaderProps {
  testId?: string;
}

/** Brand block above the auth cards, with the logo linking back to the landing page. */
export function AuthBrandHeader({
  testId = "auth-brand-logo",
}: AuthBrandHeaderProps) {
  const brandHomeRoute = useBrandHomeRoute();

  return (
    <div className="auth-brand">
      <AbcFitnessBrandLogo
        to={brandHomeRoute}
        theme="light"
        testId={testId}
      />
      <div className="auth-brand__name">ABC Fitness Developer Portal</div>
    </div>
  );
}
